import type { NewProjectQuickFormValues } from "../../../../libs/form-validations/new-project-quick";

export const quickDefaultValues: NewProjectQuickFormValues = {
    name: "",
    type: "Residential",
    salesmanName: null,
    customerName: "",
    customerPhoneCountry: "US",
    customerPhoneNumber: "",
    customerEmail: "",
    customerStreetAddress: "",
    customerCity: "",
    customerState: "",
    customerZipCode: "",
    customerCountry: "Denver County",
};
